import { getAxiosClient } from "../../axios-client";
import { DeleteUserRequestBody, DeleteUserResponse } from "./types";

const axiosClient = getAxiosClient();
export const deleteUser = async (body: DeleteUserRequestBody) => {
  return await axiosClient.ax.delete<DeleteUserResponse>(
    "/Users/DeleteUser",
    { data: body }
  );
};
